<template>
  <div
    ref="menu"
    v-if="! $store.getters['settingsModule/elementSidebar']"
    :class="positionClasses"
    class="wf--ml-48 wf-absolute wf-bg-white wf-rounded-lg wf-overflow-hidden wf-border-4 wf-border-white wf-shadow-md wf-w-56 wf-z-50"
  >
    <ul>
      <EditorElementMenuList
        @updateOpen="updateOpen"
        trigger="content"
        title="Content"
        :open="open"
      >
        <template slot="list">
          <component
            v-for="property in contentProperties"
            :key="property.key"
            :is="property.component"
            :text="property.text"
            :property="property.property"
            :element="element"
            :module="module"
          ></component>
        </template>
      </EditorElementMenuList>

      <EditorElementMenuList
        @updateOpen="updateOpen"
        trigger="style"
        title="Styles"
        :open="open"
      >
        <template slot="list">
          <component
            v-for="property in styleProperties"
            :key="property.key"
            :only="property.only"
            :except="property.except"
            :classes="property.class"
            :is="property.component"
            :element="element"
            :module="module"
          ></component>
        </template>
      </EditorElementMenuList>
    </ul>
  </div>
</template>

<script>
  import ContentText from '../../MenuProperties/ContentText'
  import ElementMenu from '../../contracts/ElementMenu'
  export default ElementMenu.extend({
    components: {
      ContentText
    },
    data() {
      return {
        open: 'content',
      }
    },
    computed: {
      module() {
        return this.parent.module
      },
      element() {
        return this.parent.element
      },
      family() {
        return this.parent.family
      },
      id() {
        return this.parent.id
      },
      contentProperties() {
        return this.parent.properties.content;
      },
      styleProperties() {
        return this.parent.properties.styles
      }
    }
  })
</script>
